import * as orderExtrasApi from '@/api/orders/orderExtras'

const orderExtras = {
  state: {
  },
  mutations: {
  },
  actions: {
    getOrderExtras ({ commit }, data) {
      return new Promise((resolve, reject) => {
        orderExtrasApi.getOrderExtras(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },

  }
}

export default orderExtras
